// src/features/bookings/components/BookingDetail/tabs/BookingPaymentsTab.jsx
import React, { useState } from 'react';
import Button from '../../../../../shared/components/ui/Button';
import { createPayment, deletePayment } from '../../../../../api';

const CalIcon = () => (
  <svg width="11" height="11" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="3" width="14" height="12" rx="2"
      stroke="currentColor" strokeWidth="1.2"/>
    <path d="M5 1v4M11 1v4M1 7h14"
      stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

const fmt = (n) => parseFloat(n || 0).toLocaleString('en-US', {
  minimumFractionDigits: 0, maximumFractionDigits: 0,
});

const BookingPaymentsTab = ({ booking, onDataRefresh, canAdd, canDelete, styles }) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    amount: '', payment_date: new Date().toISOString().slice(0, 10), notes: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]           = useState('');

  const handleChange = e =>
    setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleAdd = async e => {
    e.preventDefault();
    if (!formData.amount || !formData.payment_date) {
      setError('يرجى ملء حقلي المبلغ والتاريخ.'); return;
    }
    setSubmitting(true); setError('');
    try {
      await createPayment({ ...formData, booking: booking.id });
      setFormData({ amount: '', payment_date: new Date().toISOString().slice(0, 10), notes: '' });
      setShowForm(false);
      onDataRefresh();
    } catch { setError('حدث خطأ أثناء حفظ الدفعة.'); }
    finally { setSubmitting(false); }
  };

  const handleDelete = async id => {
    if (!window.confirm('هل أنت متأكد من حذف هذه الدفعة؟')) return;
    try { await deletePayment(id); onDataRefresh(); }
    catch { alert('فشل حذف الدفعة.'); }
  };

  const payments = booking.payments ?? [];

  return (
    <>
      {/* قائمة الدفعات */}
      {payments.length > 0 ? (
        <div className={styles.paymentsList}>
          {payments.map(p => (
            <div key={p.id} className={styles.paymentRow}>
              <div className={styles.paymentLeft}>
                <span className={styles.paymentAmount}>+ {fmt(p.amount)} د.ع</span>
                <span className={styles.paymentDate}>
                  <CalIcon /> {p.payment_date}
                </span>
              </div>
              <span className={styles.paymentNote}>{p.notes || '—'}</span>
              {canDelete && (
                <Button variant="danger" size="sm" onClick={() => handleDelete(p.id)}>
                  حذف
                </Button>
              )}
            </div>
          ))}
        </div>
      ) : (
        !showForm && <p className={styles.emptyTab}>لا توجد دفعات مسجلة.</p>
      )}

      {/* نموذج الإضافة */}
      {showForm && (
        <form onSubmit={handleAdd} className={styles.inlineForm}>
          <div className={styles.inlineFormRow}>
            <div>
              <label className={styles.formFieldLabel}>المبلغ *</label>
              <input type="number" name="amount" value={formData.amount}
                onChange={handleChange} placeholder="المبلغ" required />
            </div>
            <div>
              <label className={styles.formFieldLabel}>تاريخ الدفعة *</label>
              <input type="date" name="payment_date" value={formData.payment_date}
                onChange={handleChange} required />
            </div>
          </div>
          <div>
            <label className={styles.formFieldLabel}>ملاحظات</label>
            <textarea name="notes" value={formData.notes} onChange={handleChange}
              rows={2} placeholder="ملاحظات اختيارية..." style={{ resize: 'vertical' }} />
          </div>
          {error && <p className={styles.errorMsg}>{error}</p>}
          <div className={styles.formActions}>
            <Button variant="secondary" size="sm" type="button"
              onClick={() => setShowForm(false)}>
              إلغاء
            </Button>
            <Button variant="primary" size="sm" loading={submitting} type="submit">
              حفظ الدفعة
            </Button>
          </div>
        </form>
      )}

      {/* زر إضافة */}
      {canAdd && !showForm && (
        <button className={styles.addBtn} type="button" onClick={() => setShowForm(true)}>
          + إضافة دفعة جديدة
        </button>
      )}
    </>
  );
};

export default BookingPaymentsTab;